import React from "react";

import { ArrowForward } from "@mui/icons-material";
import { Box, Button, TextField, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";

import { colors } from "@/theme/overrides/colors";

import { useEditing } from "./utils/formElement";
import Section from "../store/Section";

interface Props {
  section: Section;
}

const SectionButton: React.FC<Props> = observer(({ section }) => {
  const editing = useEditing(section);

  return (
    <>
      {!editing.value ? (
        <div>
          <Button
            variant="contained"
            endIcon={!section.isLast && <ArrowForward />}
            onClick={editing.start}
          >
            {section.arguments.buttonLabel || section.defaultButtonLabel}
          </Button>
        </div>
      ) : (
        <Box bgcolor={colors.white} px={5} py={3}>
          <Box bgcolor={colors.light} p={5} borderRadius={2}>
            <Box width="357px">
              <Typography
                variant="subtitle2"
                fontWeight="600"
                color={colors.gray}
                pb={3}
              >
                Button Label
              </Typography>
              <TextField
                fullWidth
                sx={{ marginBottom: 4 }}
                defaultValue={
                  section.arguments.buttonLabel || section.defaultButtonLabel
                }
                onChange={(e) =>
                  section.setArgument("buttonLabel", e.target.value)
                }
              />
              <Box display="flex" justifyContent="end">
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{ marginRight: 3 }}
                  onClick={editing.cancel}
                >
                  Cancel
                </Button>
                <Button variant="contained" onClick={editing.stop}>
                  Save Changes
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
});

export default SectionButton;
